export const enum ClaimSetCreationStep {
  IncidentType,
}
